<template>
  <div class="">
    <van-list v-show="!showPopup" offset="10" class="list-box">
      <van-cell v-for="(item,index) in typeList" :key="index" center is-link @click="changeType(index)">
        <template #title>
          <span class="custom-title">{{item.name}}</span>
        </template>
      </van-cell>
    </van-list>
    <van-popup v-model="showPopup" closeable position="right" :style="{ width: '100%','height':'100%' }" get-container="body">
      <div class="setting-right-content">
        <page001 v-if="showPage == 'page001'" ref="page001" @closePage="closePage"></page001>
        <page002 v-if="showPage == 'page002'" ref="page002" @closePage="closePage"></page002>
        <page003 v-if="showPage == 'page003'" ref="page003" @closePage="closePage"></page003>
        <page004 v-if="showPage == 'page004'" ref="page004" @closePage="closePage"></page004>
        <page005 v-if="showPage == 'page005'" ref="page005" @closePage="closePage"></page005>
        <page006 v-if="showPage == 'page006'" ref="page006" @closePage="closePage"></page006>
        <page007 v-if="showPage == 'page007'" ref="page007" @closePage="closePage"></page007>
        <page008 v-if="showPage == 'page008'" ref="page008" @closePage="closePage"></page008>
        <page009 v-if="showPage == 'page009'" ref="page009" @closePage="closePage"></page009>
        <page010 v-if="showPage == 'page010'" ref="page010" @closePage="closePage"></page010>
        <page011 v-if="showPage == 'page011'" ref="page011" @closePage="closePage"></page011>
        <pasthistory v-if="showPage == 'pasthistory'" ref="pasthistory" @closePage="closePage"></pasthistory>
        <family v-if="showPage == 'family'" ref="family" @closePage="closePage"></family>
        <treatment v-if="showPage == 'treatment'" ref="treatment" @closePage="closePage"></treatment>
        <bq417 v-if="showPage == 'bq417'" ref="bq417" @closePage="closePage" disabled></bq417>
      </div>
    </van-popup>

  </div>
</template>

<script>
  // 引入服务组件

  /**
   * 特殊说明 2022-06-10
   * 手机端比电脑端多了一个患者查看,要求无法编辑 
   * 本身手机端体格检查模块,有一些有文件上传,有一些没有,就导致有一些page页面有保存功能,有一些没有
   * 在患者模式下,为了代码区分,把原有页面复制了一份,然后去掉了其中所有页面的保存功能
   * 在2022-06-10 修改中,将既往史(pasthistory) 、家族史(family) 、影像检查(page010) 、不良反应(page011) 、诊疗方案(treatment) 、临床事件(bq417) 加入了体格检查页面
   * 因为page001-page011都复制了一份,所以都单独修改了保存按钮和文件
   * 将既往史(pasthistory) 、家族史(family)  、诊疗方案(treatment)  、临床事件(bq417)  四个不在page中,单独管理
   * 只有 临床事件(bq417) 有保存功能,所有 bq417 单独加了一个disabled 属性管理
   * 
   * **/
  import componentsModel from '../../base/components.js'
  import page001 from './page/page001'
  import page002 from './page/page002'
  import page003 from './page/page003'
  import page004 from './page/page004'
  import page005 from './page/page005'
  import page006 from './page/page006'
  import page007 from './page/page007'
  import page008 from './page/page008'
  import page009 from './page/page009'
  import page010 from './page/page010'
  import page011 from './page/page011'
  import pasthistory from '../pasthistory/detail'
  import family from '../family/detail'
  import treatment from '../treatment/detail'
  import bq417 from '../../bq417/detail'
  export default {
    name: "page",
    data() {
      return {
        typeList: [{
          name: "体格检查",
          router: "page001"
        }, {
          name: "乙肝两对半定量",
          router: "page002"
        }, {
          name: "乙肝病毒DNA",
          router: "page003"
        }, {
          name: "血常规",
          router: "page004"
        }, {
          name: "生化全套",
          router: "page005"
        }, {
          name: "血清甲胎蛋白",
          router: "page006"
        }, {
          name: "甲状腺功能",
          router: "page007"
        }, {
          name: "自身抗体",
          router: "page008"
        }, {
          name: "甲/丙/丁/戊/HIV抗体",
          router: "page009"
        }, {
          name: "影像检查",
          router: "page010"
        }, {
          name: "不良反应",
          router: "page011"
        }, {
          name: "诊疗方案",
          router: "treatment"
        }, {
          name: "临床事件",
          router: "bq417"
        }],
        showPage: "page001",
        showPopup: false
      }
    },
    components: {
      ...componentsModel,
      page001,
      page002,
      page003,
      page004,
      page005,
      page006,
      page007,
      page008,
      page009,
      page010,
      page011,
      pasthistory,
      family,
      treatment,
      bq417
    },
    methods: {
      //修改类型
      changeType: function(index) {
        this.showPage = this.typeList[index].router
        this.showPopup = true
      },
      Save: function() {
        this.$refs[this.showPage].SaveInfo()
      },
      closePage: function() {
        this.showPage = ""
        this.showPopup = false
      }
    },
    mounted() {
      //判断是否基线，插入基本数据
      if (JSON.parse(sessionStorage.getItem('bq400')).bq400999 == 0) {
        // 前面推入数组
        this.typeList.unshift({
          name: "既往史",
          router: "pasthistory"
        }, {
          name: "家族史",
          router: "family"
        })
        this.showPage = "phyicalCheck" //this.typeList[0].router
      }
    }
  }
</script>

<style scoped>
  .van-cell {
    height: 56px;
  }
</style>
